<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_2"></a>Text copyright © 2015 by Chronicle Books LLC.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN: 978-1-4521-4734-5 (hc)<br/>ISBN: 978-1-4521-4807-6 (epub2)<br/>ISBN: 978-1-4521-5844-0 (epub3)<br/>ISBN: 978-1-4521-5847-1 (mobi)</p>
<p>Designed by Ben Kither<br/>Picture Editor, Julien Tomasello</p>
<p>Chronicle Books LLC<br/>680 Second Street,<br/>San Francisco, California, 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05copyright.vue?5ab53581